module.exports = __webpack_public_path__ + "static/36-865389fd2c70b1b698ff90a41f6a29f7.png";